import * as styles from './hamburger.styles'

type Props = {
  onClick: () => void
  opened: boolean
  inverted?: boolean
}

export const Hamburger = ({ onClick, opened, inverted = false }: Props) => (
  <button
    aria-controls="navigation"
    aria-expanded={opened}
    aria-label="Menu"
    css={[
      styles.hamburger,
      opened && styles.hamburgerOpened,
      inverted && styles.inverted,
    ]}
    type="button"
    onClick={onClick}
  >
    <span></span>
    <span></span>
    <span></span>
  </button>
)
